export default "__VITE_ASSET__308052f8__"